import { BorderRadius, Color, Spacing, zIndex } from '@billy/design-system'
import styled from '@emotion/styled'
import { transparentize } from 'polished'

interface HoverCardProps {
  visible?: boolean
}

export const HoverCard = styled.div<HoverCardProps>`
  display: flex;
  opacity: ${({ visible = false }) => (visible ? 1 : 0)};
  flex-direction: column;
  gap: ${Spacing.S20};
  min-width: 220px;
  max-width: 320px;
  padding: ${Spacing.S12};
  border: 1px solid ${Color.Purple600};
  border-radius: ${BorderRadius.R10};
  z-index: ${zIndex.Tooltip};
  background-color: ${Color.White};
  box-shadow: 0 2px 8px ${transparentize(0.88, Color.Black)};
  pointer-events: ${({ visible = false }) => (visible ? 'auto' : 'none')};
  transition: opacity 150ms ease;
`

export const HoverTrigger = styled.span`
  display: inline-flex;
  flex-shrink: 0;
`
